// Mind2Magic CRM — Sara's Content Blocks for Premium Itinerary (Magic Planner 1.5)
// Extracted verbatim from Sara's 6 reference PDF itineraries.
// These are Sara's EXACT words — do NOT add descriptions, age categories, or anything
// that isn't in her PDFs. Rides are checkbox lists with short one-liner opinions.
// Per-child notes reference kids BY NAME (auto-generated from grupoViajeros).

// ── HEIGHT REQUIREMENTS (from backend parks.py) ──────────────────────────
// Duplicated here so frontend doesn't need backend calls for child notes
export const HEIGHT_REQUIREMENTS = {
  // Magic Kingdom
  seven_dwarfs_mine_train: 97,
  tron_lightcycle: 122,
  space_mountain: 112,
  big_thunder_mountain: 102,
  barnstormer: 89,
  tomorrowland_speedway: 81,
  // Hollywood Studios
  slinky_dog_dash: 97,
  tower_of_terror: 102,
  rise_of_resistance: 102,
  millennium_falcon: 97,
  alien_swirling: 81,
  star_tours: 102,
  // EPCOT
  test_track: 102,
  guardians_of_galaxy: 107,
  mission_space_orange: 112,
  mission_space_green: 102,
  soarin: 102,
  // Animal Kingdom
  avatar_flight_of_passage: 112,
  expedition_everest: 112,
  kali_river_rapids: 97,
  // Universal Studios Orlando
  hollywood_rip_ride: 130,
  hagrids_motorbike: 122,
  velocicoaster: 130,
  hulk_coaster: 137,
  jurassic_world: 107,
  // Epic Universe
  starfall_racers: 122,
  stardust_racers: 122,
}

export const AGE_TO_HEIGHT = {
  2: 87, 3: 95, 4: 102, 5: 109, 6: 115,
  7: 121, 8: 127, 9: 132, 10: 137, 11: 143, 12: 149,
}

export function canRide(attractionKey, age) {
  if (!HEIGHT_REQUIREMENTS[attractionKey]) return true
  const minH = HEIGHT_REQUIREMENTS[attractionKey]
  const childH = AGE_TO_HEIGHT[age] || (age > 12 ? 160 : 85)
  return childH >= minH
}

// ── GREETING & WELCOME ───────────────────────────────────────────────────
export const GREETING = {
  // {familyName} replaced at generation time
  heading: '¡¡Se van a Disney Familia {familyName}!!',
  headingUniversal: '¡¡Se van a Universal Familia {familyName}!!',
  headingOrlando: '¡¡Se van a Orlando Familia {familyName}!!!!',
  headingCombo: '¡¡Se van a Disney y Universal Familia {familyName}!!',

  welcome: `Bienvenidos a un viaje maravilloso en el que estoy encantada de acompañarlos.

En esta guía encontrarás un recordatorio de las filas rápidas. Cómo aconsejo realizar los parques de acuerdo a sus expectativas de viaje y mi experiencia. Así como qué lugares para comer recomiendo.`,
}

// ── AGENDA (date-by-date summary) ────────────────────────────────────────
// Generated dynamically from lead.travelDate, hotels, parkEntries
// Format from Sara's PDFs:
// | Fecha | Día | Actividad |
// | Lun 24 Nov | Día 1 | Llegada + Check-in Hotel |
// | Mar 25 Nov | Día 2 | Magic Kingdom ⭐ |
// etc.

// ── LIGHTNING LANE / DATOS IMPORTANTES ───────────────────────────────────
// Matches Sara's "Datos importantes" section structure from real PDFs
export const LIGHTNING_LANE = {
  title: 'Datos importantes',

  intro: `TODO SOBRE LAS FILAS RÁPIDAS
Las filas rápidas son algo que recomiendo especialmente para fechas de alta afluencia de público. Normalmente por el tamaño de Magic Kingdom recomiendo siempre comprar el MultiPass. Así como el SinglePass en Hollywood Studios para Rise of the Resistance. Esto es solo una recomendación y si está considerado dentro del presupuesto del viaje.`,

  multipass: {
    title: 'LIGHTING LANE MULTI PASS',
    priceRange: 'Precio oscila entre ~$19 y ~$35',
    perPark: [
      { park: 'Magic Kingdom', price: '$35/persona' },
      { park: 'Hollywood Studios', price: '$25/persona' },
      { park: 'EPCOT', price: '$22/persona' },
      { park: 'Animal Kingdom', price: '$19/persona' },
    ],
    buyAdvance: 'Tomar {bookingDays} días antes los turnos para las atracciones que deseen con el Lighting Lane Multi Pass. En cada parque podrán reservar 3 rides o experiencias. Estas experiencias podrán reservarlas de la siguiente manera (Ver cuadro)',
  },

  singlePass: {
    title: 'FILA INDIVIDUAL (LIGHTING LANE SINGLE PASS)',
    buyAdvance: 'Se puede comprar hasta 7 DÍAS ANTES DEL PARQUE.',
    rules: [
      'Podrás comprar hasta 2 Lightning Lane Single Pass por día',
      'El precio variará dependiendo de la atracción y la fecha',
      'Solo puedes reservar 1 vez por atracción',
    ],
    perPark: [
      { park: 'En Animal Kingdom', items: 'Avatar Flight of Passage $16 usd aprox' },
      { park: 'En Hollywood Studios', items: 'Rise of the resistance $22 usd aprox' },
      { park: 'En Magic Kingdom', items: 'Seven Dwarfs Mine Train $13 aprox\n                    TRON $21 aprox' },
      { park: 'En EPCOT', items: 'Guardians of the Galaxy: Cosmic Rewind $15 usd aprox' },
    ],
  },

  multiPassExplanation: 'Recuerden que tendrán nuevas oportunidades para tomar un turno de Lighting Lane Multi Pass (fila rápida, aparece en el app como LL) en cuanto hayan soltado uno de los turnos previamente tomados. Solo se podrá tomar UN (1) turno al día por atracción, es decir que no podrás volver a programar turno para una atracción que ya disfrutaste.',

  tipBoard: 'En la parte superior de la aplicación de Disney en My Day Tip Board aparecen todas las atracciones y bajo el símbolo LL MultiPass Experience encontrarán el horario disponible más temprano para tomar turno en las diferentes atracciones que tienen disponibilidad. Recuerden que en esta parte aparecen tanto tiempo de espera normales (Standby Lane) y Horarios de turno (LL) MultiPass Experience o LL SinglePass Experience (en el caso de las filas por pago individual).',

  castMembers: `Recuerda que en cuanto reclamen su turno, podrán pedir uno nuevo.
Siempre los Cast Members (miembros de Disney) están listos para ayudarlos ante cualquier inconveniente, igualmente pueden ir a guest services en caso que lo necesiten.
Y siempre podrán comunicarse conmigo por WhatsApp en caso de que así lo requieran, SIEMPRE intentaré atenderlos tan pronto como sea posible.`,

  cancellation: 'OJO!! Cuando por alguna razón la atracción para la que tienen un turno, la cierran temporalmente, o tiene algún tipo de retraso y Disney cancela el turno, te regalarán siempre un turno que queda abierto para CUALQUIER atracción que desees en cualquier momento del día.',

  creditCardWarningPrefix: 'ADVERTENCIA!!!',
  creditCardWarningText: 'Puede que cuando vayan a comprar el Multi Pass no les tome su tarjeta de crédito si no es de USA, lo que recomiendo es que cuando pidan número de tarjeta de crédito no poner dirección en Colombia sino la del Hotel donde se están hospedando.',

  reminderDisney: 'RECUERDEN QUE SOLO SE PUEDE COMPRARLA HASTA 7 DÍAS ANTES. APROVECHEN ESTE BENEFICIO DE SER HUESPEDES DE DISNEY.',
  reminderNonDisney: 'RECUERDEN QUE SOLO SE PUEDE COMPRARLA HASTA 3 DÍAS ANTES.',

  comodin: '*Lo que menciono en la programación como comodín, es porque ustedes deben revisar en ese instante los horarios y decidir si siguen a la atracción más cercana al show o si entran al show y luego van a la atracción. Así como también si está lloviendo, pueden ser excelentes lugares para escampar.',
}

// ── DISNEY SPRINGS RESTAURANTS ───────────────────────────────────────────
// 100% reusable — identical across all 6 Disney PDFs
export const DISNEY_SPRINGS = {
  title: 'Si van a Disney Springs',
  intro: '(esta zona es gratis, pueden ingresar cuando quieran, hay restaurantes y actividades, es como el "centro" de Disney)',

  categories: [
    {
      name: 'Servicio a la mesa',
      restaurants: [
        { name: 'Jaleo by José Andrés', type: 'Tapas españolas', tip: 'Un restaurante de tapas españolas muy bueno.' },
        { name: 'Morimoto Asia', type: 'Asiática', tip: 'Cocina asiática súper top. Sushi y los noodles.' },
        { name: 'The Boathouse', type: 'Mariscos', tip: 'Vista linda al lago.' },
      ]
    },
    {
      name: 'Servicio rápido',
      restaurants: [
        { name: 'The Polite Pig', type: 'BBQ', tip: 'Costillas, pollo y cerdo desmenuzado.' },
        { name: 'Earl of Sandwich', type: 'Sandwiches', tip: 'Un clásico.' },
        { name: 'Blaze Fast-Fire\'d Pizza', type: 'Pizza', tip: 'Pizzas personalizables cocinadas al instante.' },
        { name: 'Morimoto Asia Street Food', type: 'Asiática', tip: 'La versión rápida del Morimoto, ramen, costillas.' },
      ]
    },
    {
      name: 'Temáticos (son servicio a la mesa)',
      restaurants: [
        { name: 'Rainforest Cafe', type: 'Americana', tip: 'Selva tropical con sonidos de animales, lluvias.' },
        { name: 'T-Rex', type: 'Americana', tip: 'Dinosaurios animatrónicos.' },
        { name: 'Planet Hollywood', type: 'Americana', tip: 'Decorado con objetos icónicos de películas.' },
      ]
    },
  ],
}

// ── CHECK-IN DAY TEMPLATE ────────────────────────────────────────────────
// {hotelName}, {checkInDate} replaced at generation time
export const CHECK_IN_DAY = {
  title: 'Check-in',

  template: `Hoy es día de llegada. El check-in en {hotelName} es a las 3:00 PM (a veces dejan hacer check-in temprano si hay disponibilidad, pregunten).

Recuerden hacer Mobile Check-in desde la App si quieren, sino pueden hacerlo en el lobby directamente.

El primer día el hotel carga $100 USD de depósito como "seguro", y estos se devuelven una vez se haga check out. Yo personalmente recomiendo (es solo una sugerencia) hacerlo con Tarjeta de Crédito, ya que con tarjeta débito algunas veces tardan en reembolsar más tiempo.

Tengan en cuenta que el check-in es a las 3:00 pm pero pueden disfrutar del hotel todo el día.
Pueden dejar sus maletas en una zona especial para check-in y ustedes pueden quedarse disfrutando de lo que más quieran, incluido la piscina del hotel.

Si llegan temprano:
• Descarguen la app My Disney Experience y configuren todo:
  - Vincular boletos
  - Reservar Lightning Lane (si lo compraron)
  - Verificar reservaciones de restaurantes
• Pueden ir a Disney Springs a almorzar y explorar

Cosas importantes para empacar:
• Lleven ropa y zapatos cómodos, van a caminar MUCHO
• Bloqueador solar y gorra/sombrero, el sol en Florida es muy fuerte
• Batería portátil para el celular, la app de Disney consume mucha batería
• Poncho o capa de lluvia (en Orlando llueve casi todos los días, pero pasa rápido)
• Botella de agua reutilizable (hay fuentes de agua gratis en todos los parques)

Igualmente este día pueden aprovechar y comprar snacks, souvenirs o cosas para preparar sandwich en caso que quieran complementar su plan de comidas. Pueden hablar con Carlos, la persona que les recomiendo para transporte, que él los puede llevar y recoger.

Este día pueden ir a Disney Springs, recomiendo hacerlo y regresar antes de las 8 pm, para descansar, vienen unos días muy muy movidos.`,

  magicalExtrasNote: 'Tienen también magical extras incluidos en sus paquetes, como golfito o algunas actividades especiales dentro del complejo Disney. Allí tienen descuentos para tiendas en Disney Springs, es importante reclamarlo en el hotel, si no dejan algo en su cuarto que diga MAGICAL EXTRAS.',

  firstTimeNote: `Si es su primera vez, tómense un momento para familiarizarse con la app. Ahí pueden ver tiempos de espera en tiempo real, horarios de shows, y hacer Mobile Order para no hacer fila en restaurantes.`,
}

// ── REST DAY / CHECKOUT DAY ───────────────────────────────────────────────
export const REST_DAY = {
  title: 'Día de Descanso',
  template: `Disfruten mucho el hotel, es espectacular. Recarguen energías.

Pueden comer en el food court del hotel. Recuerden que pueden hacer Mobile Order desde la app para no hacer fila.

Pueden visitar el Boardwalk de Disney al final de la tarde, es muy lindo, venden helados muy ricos y es una zona agradable para caminar.

Si quieren ver los fuegos artificiales de Epcot sin entrar al parque, pueden verlos desde el Boardwalk a las 9:00 pm.`,

  miniGolf: 'Tienen Magical Extras incluidos que les dan descuento en mini golf. Pueden ir a Fantasia Gardens o a Winter Summerland. Link: https://disneyworld.disney.go.com/recreation/fantasia-gardens-fairways-miniature-golf/',

  artOfAnimation: 'Si quieren visitar otro hotel de Disney (Art of Animation es muy lindo, tiene tematica de Nemo, Cars, La Sirenita y El Rey Leon), pueden tomar bus a Disney Springs y de ahi bus al hotel.',

  shoppingOption: `Si quieren ir de compras, los recomendados:
* Para cosas de casa: HomeGoods, Ross, TJ Maxx
* Outlets: Premium Outlets (cualquiera de los dos tiene muchas opciones)
* Zapatos: DSW y todas las tiendas de marcas en los Outlets
* Ropa y cosas de Disney: Primark en Florida Mall
* Elementos deportivos: Dick's`,

  hotelDining: 'Recuerden que el hotel tiene comida en el food court: les recomiendo revisar las opciones, normalmente la pizza pepperoni grande es muy buena porcion.',
}

// ── HOTEL FOOD COURT RECOMMENDATIONS ─────────────────────────────────────
// Sara ALWAYS includes hotel dining tips
export const HOTEL_DINING_RECS = {
  breakfast: [
    'Bandeja de Waffles o de Pancakes (tiene huevo, salchicha, tocineta y papa)',
    'Parfait de yogurt con granola (es un snack)',
    'Avena trasnochada (overnight oats), es un snack',
    'Fruta fresca',
  ],
  dinner: [
    'Beef and Vegetable Stir-fry',
    'Mojo-roasted Chicken',
    'Hamburguesas',
  ],
  tips: [
    'La pizza pepperoni grande es muy buena porcion y la gente la ama (les quitan 2 creditos de quick service).',
    'La sopita de tomate y albahaca es un snack y me encanta :)',
    'Pueden hacer Mobile Order desde la app para no hacer fila en el food court.',
  ],
}

export const CHECKOUT_DAY = {
  title: 'Día de Check-out',
  template: `El check-out es a las 11:00 AM. Pueden dejar las maletas en Bell Services (en el lobby) si su vuelo es más tarde y seguir disfrutando del hotel o los parques.

Su plan de comidas está vigente hasta las 11:59 pm del día de check-out. Aprovechen para usar todos los créditos que les queden.

Tengan en cuenta que aunque hagan check-out, pueden disfrutar del hotel todo el día, incluida la piscina.

Recuerden revisar la cuenta del hotel antes de salir, el depósito de $100 USD que les cobraron al hacer check-in se devuelve automáticamente (puede tardar unos días en reflejarse).

Si tienen tiempo antes del vuelo, pueden ir a Disney Springs o hacer compras de último momento.

¡Espero que hayan tenido un viaje inolvidable! Me cuentan cómo les fue.`,
}

export const HOTEL_TRANSITION = {
  title: 'Cambio de Hotel',
  template: `Check-out a las 11:00 AM. Pueden dejar las maletas en Bell Services mientras hacen el traslado.

Check-in en el nuevo hotel es a las 3:00 PM (a veces dejan hacer check-in temprano si hay disponibilidad).

Este día pueden aprovechar para descansar, explorar el nuevo hotel, disfrutar la piscina, o ir de compras.`,
}

// ── PER-PARK RIDE ORDERS (Sara's voice — checkbox lists) ─────────────────
// These are Sara's exact ride orders with her one-liner opinions.
// NO descriptions. NO age categories. Just checkbox + name + Sara's comment.
// Per-child height notes are generated dynamically by docx-generator.js

export const PARK_RIDES = {
  mk: {
    name: 'Magic Kingdom',
    code: 'mk',
    earlyEntryGate: 'Tomorrowland (por Mainstreet hacia donde está el castillo, toman a mano derecha)',
    arrivalTip: 'Recomiendo estar en el parque tipo 7:15 am, para hacer todo el proceso de ingreso.',
    llTip: 'Les recomiendo mucho comprar Lighting Lane individual para Seven Dwarfs Mine Train y TRON — son las que más fila tienen.',
    noCoasterLLTip: 'Les recomiendo comprar Lighting Lane Multi Pass — tomen Peter Pan\'s Flight, Jungle Cruise, y Winnie the Pooh como primeros turnos.',

    llGroups: {
      group1: {
        label: 'Grupo 1 (escojan UNA)',
        rides: [
          'Jungle Cruise',
          "Peter Pan's Flight",
          'Space Mountain',
          "Tiana's Bayou Adventure",
        ],
      },
      group2: {
        label: 'Grupo 2 (escojan DOS o TRES)',
        rides: [
          'The Barnstormer',
          'Buzz Lightyear',
          'Dumbo',
          'Haunted Mansion',
          "It's a Small World",
          'Mad Tea Party',
          'Magic Carpets of Aladdin',
          'Winnie the Pooh',
          'PhilharMagic',
          'Monsters Inc Laugh Floor',
          'Pirates of the Caribbean',
          'Tomorrowland Speedway',
          'Under the Sea',
        ],
      },
      singlePass: [
        { name: 'Seven Dwarfs Mine Train', price: '$15-20 USD', key: 'seven_dwarfs_mine_train' },
        { name: 'TRON Lightcycle Run', price: '$20-25 USD', key: 'tron_lightcycle' },
      ],
    },

    // Sara's CONSISTENT walking route (verified across 7 itineraries)
    // Rides are grouped — PARK_NARRATIVE connectors go between groups
    rideOrder: [
      // Group 1: Opening rush (go DIRECT)
      { name: 'Seven Dwarfs Mine Train', key: 'seven_dwarfs_mine_train', sara: 'Vayan DIRECTO apenas entren, sin tomar fotos, sin parar aun.', isCoaster: true, coasterType: 'suave', group: 1 },
      { name: "Tiana's Bayou Adventure", key: 'tianas_bayou', sara: 'Se pueden mojar, llevar camiseta de sobra para todos.', group: 1 },
      // Group 2: Adventureland/Frontierland loop
      { name: 'Pirates of the Caribbean', key: 'pirates', sara: '', group: 2 },
      { name: 'Jungle Cruise', key: 'jungle_cruise', sara: '', group: 2 },
      { name: 'Big Thunder Mountain', key: 'big_thunder_mountain', sara: '', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'No es tan intensa, es mas el ruido. Si prefieren no, la pueden omitir.', group: 2 },
      { name: 'Haunted Mansion', key: 'haunted_mansion', sara: '', group: 2 },
      // Group 3: Castle area + comodin (narrative: castle break, cavalcade, PhilharMagic)
      { name: 'PhilharMagic', key: 'philharmagic', sara: 'Me encanta y normalmente a los ninos les FASCINA.', group: 3 },
      // Group 4: Fantasyland (after lunch + parade)
      { name: "Peter Pan's Flight", key: 'peter_pan', sara: 'A mi esta me parece no tan chevere pero es un clasico.', group: 4 },
      { name: 'Under the Sea', key: 'under_the_sea', sara: '', group: 4 },
      { name: "It's a Small World", key: 'its_a_small_world', sara: '', group: 4 },
      { name: 'Winnie the Pooh', key: 'winnie_the_pooh', sara: '', group: 4 },
      // Group 5: Tomorrowland (evening)
      { name: 'Buzz Lightyear', key: 'buzz_lightyear', sara: '', group: 5 },
      { name: 'Space Mountain', key: 'space_mountain', sara: '', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'Pueden hacerla por fila Single Rider si alguien se anima. Solo cabe una persona por carro.', group: 5 },
      { name: 'TRON Lightcycle Run', key: 'tron_lightcycle', sara: 'OJO!!!! se los recomiendo, arranca duro!', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'Es la montana rusa mas nueva de Magic Kingdom. Si se animan, vale la pena.', group: 5 },
    ],

    // Sara's EXACT "Si tienen tiempo" list (verified across 7 itineraries)
    ifTimePermits: [
      { name: 'Tomorrowland Speedway', key: 'tomorrowland_speedway', sara: '' },
      { name: 'Prince Charming Regal Carousel', sara: '' },
      { name: 'Astro Orbiter', sara: '' },
      { name: 'The Barnstormer', key: 'barnstormer', sara: '', isCoaster: true, coasterType: 'suave' },
      { name: 'Dumbo', sara: '' },
      { name: 'Mad Tea Party', sara: '' },
      { name: 'Magic Carpets of Aladdin', sara: '' },
    ],

    notRecommended: [
      { name: 'Monsters Inc Laugh Floor', sara: '' },
    ],

    walkingDirections: 'Ingresan directo (sin tomar fotos, sin parar aún) a Seven Dwarfs Mine Train o Tiana\'s Bayou Adventure. Salgan de allí y pasen a Pirates of the Caribbean, Jungle Cruise, y empiecen a disfrutar.',

    endOfDayTip: 'El desfile nocturno es a las 8:15 pm. Estar cerca del lugar tipo 7:30 pm, recomiendo que tomen puestos cerca del castillo y alguien vaya por cosas de comer. Pueden hacerse cerca a Frontierland. Ver el Show "Happily Ever After" a las 9:30 pm, ubicarse cerca a la estatua de Walt Disney con Mickey o si está muy lleno, cerca al restaurante Crystal Palace.',
  },

  hs: {
    name: 'Hollywood Studios',
    code: 'hs',
    earlyEntryGate: 'Entrada principal',
    arrivalTip: 'Estar en el parque tipo 7:15 am.',
    llTip: 'Les recomiendo mucho comprar Lighting Lane individual para Rise of the Resistance. SÍ O SÍ compren este, vale cada centavo, es la mejor atracción de todo Disney.',
    noCoasterLLTip: 'Les recomiendo mucho comprar Lighting Lane individual para Rise of the Resistance — no es montana rusa, es una experiencia inmersiva increible. SI O SI compren este.',

    llGroups: {
      group1: {
        label: 'Grupo 1 (escojan UNA)',
        rides: [
          "Mickey & Minnie's Runaway Railway",
          'Slinky Dog Dash',
        ],
      },
      group2: {
        label: 'Grupo 2 (escojan DOS o TRES)',
        rides: [
          'Alien Swirling Saucers',
          'Beauty and the Beast Live on Stage',
          'Disney Junior Play & Dance!',
          'For the First Time in Forever: Frozen',
          'Indiana Jones Epic Stunt Spectacular!',
          'MuppetVision 3D',
          'Star Tours – The Adventures Continue',
          'The Twilight Zone Tower of Terror',
          'Toy Story Mania!',
          'Millennium Falcon: Smugglers Run',
        ],
      },
      singlePass: [
        { name: 'Rise of the Resistance', price: '$20-25 USD', key: 'rise_of_resistance', note: 'SÍ O SÍ compren este. Vale cada centavo, es la mejor atracción de todo Disney.' },
      ],
    },

    rideOrder: [
      // Group 1: Toy Story Land rush
      { name: 'Slinky Dog Dash', key: 'slinky_dog_dash', sara: 'Vayan directo, no paren antes, no tomen fotos, nada. Este se llena DEMASIADO.', isCoaster: true, coasterType: 'suave', group: 1 },
      { name: 'Toy Story Mania', key: 'toy_story_mania', sara: '', group: 1 },
      { name: 'Alien Swirling Saucers', key: 'alien_swirling', sara: '', group: 1 },
      // Group 2: Galaxy's Edge
      { name: 'Millennium Falcon: Smugglers Run', key: 'millennium_falcon', sara: '', group: 2 },
      { name: 'Rise of the Resistance', key: 'rise_of_resistance', sara: 'SI O SI compren este Single Pass.', group: 2 },
      { name: 'Star Tours', key: 'star_tours', sara: '', group: 2 },
      // Group 3: Central + Sunset Blvd
      { name: "Mickey & Minnie's Runaway Railway", key: 'mickey_minnie_railway', sara: 'Hacerse adelante en el momento en que los dividen en la fila.', group: 3 },
      { name: 'Tower of Terror', key: 'tower_of_terror', sara: 'Puede asustar un poquito pero normalmente les encanta.', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'No es montana rusa, es caida libre. Si se animan, normalmente les encanta a todos.', group: 3 },
    ],

    ifTimePermits: [
      { name: 'Frozen Sing-Along', sara: 'Es súper, es completamente en inglés.' },
    ],

    notRecommended: [],

    walkingDirections: 'Entrar directo a Slinky Dog (ahí en el ride máximo a las 8:20 am). No paren antes, no tomen fotos, nada, solo vayan directo. Ingresen derecho, no crucen, pasan por el lado del teatro chino y ven al fondo unas escaleras, bajan por esas escaleras y llegan a Toy Story Land.',

    endOfDayTip: 'Fantasmic! será a las 8:30 pm, estar allí idealmente entre 7:50 - 8:00 pm para hacer fila.',
  },

  ep: {
    name: 'EPCOT',
    code: 'ep',
    earlyEntryGate: 'Entrada principal o International Gateway (si toman Skyliner)',
    arrivalTip: 'Estar en el parque idealmente a las 8:00 am.',
    llTip: 'Les recomiendo mucho comprar Lighting Lane individual para Guardians of the Galaxy, es súper divertida.',
    noCoasterLLTip: 'Les recomiendo Lighting Lane Multi Pass — tomen Frozen Ever After, Remy\'s Ratatouille, y Test Track como primeros turnos.',

    llGroups: {
      group1: {
        label: 'Grupo 1 (escojan UNA)',
        rides: [
          'Frozen Ever After',
          "Remy's Ratatouille Adventure",
          "Soarin' Around the World",
          'Test Track',
        ],
      },
      group2: {
        label: 'Grupo 2 (escojan DOS o TRES)',
        rides: [
          'Disney and Pixar Short Film Festival',
          'Journey into Imagination with Figment',
          'Living with the Land',
          'Mission: SPACE',
          'The Seas with Nemo & Friends',
          'Spaceship Earth',
          'Turtle Talk with Crush',
        ],
      },
      singlePass: [
        { name: 'Guardians of the Galaxy: Cosmic Rewind', price: '$17-22 USD', key: 'guardians_of_galaxy', note: 'Montaña rusa en la oscuridad con música, increíble.' },
      ],
    },

    rideOrder: [
      // Group 1: World Showcase side (if entering via Skyliner/International Gateway)
      { name: "Remy's Ratatouille Adventure", key: 'remys_ratatouille', sara: '', group: 1 },
      { name: 'Frozen Ever After', key: 'frozen_ever_after', sara: '', group: 1 },
      // Group 2: Future World rides
      { name: 'Test Track', key: 'test_track', sara: '', group: 2 },
      { name: "Soarin' Around the World", key: 'soarin', sara: 'Intentar sentarse en la primera fila.', group: 2 },
      { name: 'Mission: SPACE', key: 'mission_space', sara: 'Nivel naranja o verde, ustedes escogen.', isCoaster: true, coasterType: 'intensa', noCoasterNote: null, group: 2 },
      // Group 3: Guardians (use Single Pass)
      { name: 'Guardians of the Galaxy', key: 'guardians_of_galaxy', sara: 'NO SE PIERDAN GUARDIANS POR FAVOR!!!', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'Es montana rusa indoor pero suave, mas que nada es la oscuridad y la musica. Si se animan, vale MUCHO la pena.', group: 3 },
    ],

    ifTimePermits: [
      { name: 'Living with the Land', key: 'living_with_land', sara: '' },
      { name: 'The Seas with Nemo', sara: '' },
      { name: 'Journey Into Imagination', sara: '' },
      { name: 'Spaceship Earth', key: 'spaceship_earth', sara: '' },
    ],

    notRecommended: [],

    walkingDirections: 'Pueden ingresar por la parte "trasera" del parque tomando el Skyliner a EPCOT por International Gateway, los deja al lado de Remy\'s Ratatouille Adventure. Si entran por la entrada principal, vayan directo hacia World Showcase y giren a la derecha hacia Francia.',

    endOfDayTip: 'Entre 8:00 y 8:30 pm estar en CANTINA SAN ANGEL para comer y ver el show nocturno de las 9:00 pm, es muy lindo.',
  },

  ak: {
    name: 'Animal Kingdom',
    code: 'ak',
    earlyEntryGate: 'Entrada principal',
    arrivalTip: 'Estar en el parque tipo 7:15 am. Animal Kingdom abre temprano y cierra temprano.',
    llTip: 'Les recomiendo mucho comprar Lighting Lane individual para Avatar Flight of Passage — la mejor atracción de Animal Kingdom.',
    noCoasterLLTip: 'Les recomiendo comprar Lighting Lane individual para Avatar Flight of Passage — no es montana rusa, es un simulador de vuelo. Vale cada centavo.',

    llGroups: {
      group1: {
        label: 'Un solo grupo (escojan TRES)',
        rides: [
          "Na'vi River Journey",
          'Kilimanjaro Safaris',
          'Expedition Everest',
          'Festival of the Lion King',
          'Kali River Rapids',
        ],
      },
      group2: null, // AK only has 1 group
      singlePass: [
        { name: 'Avatar Flight of Passage', price: '$15-18 USD', key: 'avatar_flight_of_passage', note: 'La mejor atracción de Animal Kingdom. Se siente real, van a querer repetir.' },
      ],
    },

    rideOrder: [
      // Group 1: Pandora rush
      { name: 'Avatar Flight of Passage', key: 'avatar_flight_of_passage', sara: 'Vayan derecho, sin tomarse fotos.', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'NO es montana rusa, es un simulador de vuelo. Se mueve pero no tiene caidas. Vale cada minuto de fila.', group: 1 },
      { name: "Na'vi River Journey", key: 'navi_river', sara: '', group: 1 },
      // Group 2: Africa
      { name: 'Wilderness Explorer', key: 'wilderness_explorer', sara: 'Busquen una persona vestida como Russell de la pelicula UP! y reclamen su Manual de Wilderness Explorer.', group: 2 },
      { name: 'Kilimanjaro Safaris', key: 'kilimanjaro_safaris', sara: '', group: 2 },
      { name: 'Explorar Africa', key: 'africa_explore', sara: 'Hay caminos para ver gorilas, tigres, etc.', group: 2 },
      { name: 'Festival of the Lion King', key: 'lion_king', sara: 'Idealmente al show de las 12 o 1 PM.', group: 2 },
      // Group 3: Asia + DinoLand
      { name: 'Zootopia: Better Zoogether', key: 'zootopia', sara: '', group: 3 },
      { name: 'Expedition Everest', key: 'expedition_everest', sara: 'Es espectacular.', isCoaster: true, coasterType: 'intensa', noCoasterNote: null, group: 3 },
      { name: 'Kali River Rapids', key: 'kali_river_rapids', sara: 'Pueden salir mojados, lleven camisetas para cada uno.', group: 3 },
      { name: 'Finding Nemo: The Big Blue', key: 'nemo_show', sara: '', group: 3 },
      // Group 4: Pandora at night (return)
      { name: 'Pandora de noche', key: 'pandora_night', sara: 'Regresen a Pandora una vez anochezca, esta zona de noche es muy especial!', group: 4 },
    ],

    ifTimePermits: [
      { name: 'Wildlife Express Train', sara: 'Varias cositas por hacer muy lindas en Conservation Station.' },
      { name: 'Maharajah Jungle Trek', sara: '' },
    ],

    notRecommended: [],

    walkingDirections: 'En cuanto abre el parque vayan derecho a la fila normal-standby de Avatar Flight of Passage, derecho sin tomarse fotos. Después Na\'vi River Journey.',

    endOfDayTip: 'Al final del día les recomiendo regresar a Pandora una vez anochezca ya que esta zona de noche es muy especial!',
  },
}

// ── PER-PARK SHOWS ───────────────────────────────────────────────────────
export const PARK_SHOWS = {
  mk: [
    { name: "Mickey's Magical Friendship Faire", times: '1:00p, 2:05p, 4:00p, 5:30p, 6:35p', sara: 'Show pequeño en el castillo, en una tarima a la entrada del castillo.' },
    { name: 'Festival of Fantasy Parade', times: '2:00 PM', sara: 'Desfile principal. Pueden hacerse cerca a Frontierland o en Main Street.' },
    { name: 'Happily Ever After', times: '9:30 PM', sara: 'Ubicarse cerca a la estatua de Walt Disney con Mickey, o si está muy lleno, cerca al restaurante Crystal Palace.' },
  ],
  hs: [
    { name: 'Frozen Sing-Along', times: 'Variable', sara: 'Es súper, es completamente en inglés.' },
    { name: 'Beauty and the Beast Live on Stage', times: 'Variable', sara: '' },
    { name: 'Fantasmic!', times: '8:30 PM', sara: 'Estar allí idealmente entre 7:50 - 8:00 pm para hacer fila.' },
  ],
  ep: [
    { name: 'Show nocturno EPCOT', times: '9:00 PM', sara: 'Es muy lindo.' },
  ],
  ak: [
    { name: 'Festival of the Lion King', times: 'Variable', sara: 'Idealmente al show de las 12 o 1 pm.' },
    { name: 'Finding Nemo: The Big Blue', times: 'Variable', sara: '' },
    { name: 'Zootopia: Better Zoogether', times: 'Variable', sara: '' },
  ],
}

// ── PER-PARK CHARACTERS ──────────────────────────────────────────────────
export const PARK_CHARACTERS = {
  mk: [
    { name: 'Cenicienta', location: 'Princess Fairytale Hall', hours: '9:00 am – 9:00 pm' },
    { name: 'Tiana', location: 'Princess Fairytale Hall', hours: '9:00 am – 9:00 pm' },
    { name: 'Belle', location: 'Enchanted Tales with Belle', hours: '10:30 am – 7:30 pm' },
    { name: 'Ariel', location: "Ariel's Grotto", hours: '10:00 am – 7:00 pm' },
    { name: 'Mickey', location: 'Town Square Theater', hours: '9:30 am – 7:00 pm' },
  ],
  hs: [
    { name: 'Chewbacca', location: "Galaxy's Edge", hours: '10:00 am – 6:00 pm' },
    { name: 'Kylo Ren', location: "Galaxy's Edge", hours: '10:00 am – 6:00 pm' },
    { name: 'Mickey & Minnie', location: 'Red Carpet Dreams', hours: '10:00 am – 6:00 pm' },
    { name: 'Olaf', location: 'Celebrity Spotlight', hours: '10:00 am – 6:00 pm' },
  ],
  ep: [
    { name: 'Anna & Elsa', location: 'Royal Sommerhus (Noruega)', hours: 'Variable — revisar en la app' },
    { name: 'Mulan', location: 'China', hours: 'Variable — revisar en la app' },
    { name: 'Snow White', location: 'Alemania', hours: 'Variable — revisar en la app' },
    { name: 'Mary Poppins', location: 'UK', hours: 'Variable — revisar en la app' },
  ],
  ak: [
    { name: 'Mickey & Minnie (safari outfit)', location: 'Adventurers Outpost', hours: '9:00 am – 5:00 pm' },
    { name: 'Donald (DinoLand)', location: 'DinoLand USA', hours: '9:00 am – 5:00 pm' },
  ],
}

// ── PARK ENTERTAINMENT SCHEDULE ─────────────────────────────────────────
// Sara ALWAYS includes "CONOCER PERSONAJES Y EVENTOS DURANTE EL DÍA" table
// Times are defaults — Sara adjusts per trip date. Disclaimer included.
export const PARK_ENTERTAINMENT = {
  disclaimer: '*Los horarios pueden variar dependiendo del día y la temporada. Revisar en la app My Disney Experience el día del parque.',
  mk: [
    { name: 'The Dapper Dans', location: 'Main Street', times: '9:00a, 9:50a, 10:55a, 12:40p, 1:30p, 2:15p, 3:40p', sara: 'Show pequeño en Main Street.' },
    { name: "Casey's Corner Pianist", location: 'Main Street', times: '11:10a, 12:20p, 1:40p, 2:40p, 3:40p, 4:35p, 5:55p', sara: '' },
    { name: "Mickey's Magical Friendship Faire", location: 'Castillo', times: '1:00p, 2:05p, 4:00p, 5:30p, 6:35p', sara: 'Show pequeño en el castillo, en una tarima que hay literal a la entrada del castillo.' },
    { name: 'Disney Adventure Friends Cavalcade', location: 'Main Street', times: '10:30a, 11:45a', sara: 'Pequeño desfile de personajes en Main Street, repite varias veces por si no alcanzan al primero.' },
    { name: 'Flag Retreat', location: 'Main Street', times: '5:00p', sara: 'Ceremonia de bandera en Town Square.' },
    { name: 'Disney Festival of Fantasy Parade', location: 'Main Street', times: '3:00p', sara: 'Desfile principal que les recomiendo.' },
    { name: 'Disney Starlight: Dream the Night Away', location: 'Main Street', times: '8:15p, 10:30p', sara: 'Desfile nocturno con luces en Main Street.' },
    { name: 'Happily Ever After', location: 'Castillo', times: '9:30p', sara: 'Show nocturno de fuegos artificiales.' },
    { name: 'Electrical Water Pageant', location: 'Seven Seas Lagoon', times: '8:35p', sara: 'Se ve desde los hoteles alrededor de la laguna.' },
  ],
  hs: [
    { name: 'Beauty and the Beast Live on Stage', location: 'Sunset Blvd', times: '11:00a, 1:00p, 2:00p, 4:00p, 5:00p', sara: '' },
    { name: 'Indiana Jones Epic Stunt Spectacular', location: 'Echo Lake', times: '10:45a, 12:00p, 1:15p, 3:15p, 4:30p', sara: 'Show de efectos especiales y accion.' },
    { name: 'For the First Time in Forever: Frozen', location: 'Echo Lake', times: '9:30a, 10:30a, 11:30a, 12:30p, 1:30p, 2:30p, 3:30p, 4:30p, 5:30p, 6:30p', sara: 'Es completamente en ingles.' },
    { name: 'Fantasmic!', location: 'Sunset Blvd', times: '8:30p, 10:00p', sara: 'Show nocturno.' },
  ],
  ep: [
    { name: 'Voices of Liberty', location: 'The American Adventure', times: 'Variable', sara: 'Coro a capela, muy bonito.' },
    { name: 'Mariachi Cobre', location: 'Mexico', times: 'Variable', sara: '' },
    { name: 'Canada Pavilion Entertainment', location: 'Canada', times: '2:15p, 3:30p, 5:00p, 6:15p, 7:30p', sara: '' },
    { name: 'Garden Rocks Concert Series', location: 'World Showcase', times: '5:30p, 6:45p, 8:00p', sara: 'Conciertos en vivo durante el festival Flower & Garden (primavera).' },
    { name: 'Luminous The Symphony of Us', location: 'World Showcase Lagoon', times: '9:00p', sara: 'Show nocturno de fuegos artificiales. Es muy lindo.' },
  ],
  ak: [
    { name: 'Festival of the Lion King', location: 'Africa', times: '10:00a, 11:00a, 12:00p, 1:00p, 2:00p, 3:00p, 4:00p, 5:00p', sara: 'Idealmente al show de las 12 o 1 PM.' },
    { name: 'Finding Nemo: The Big Blue... and Beyond!', location: 'Theater in the Wild', times: '11:00a, 12:00p, 1:00p, 2:30p, 3:30p, 4:30p', sara: '' },
    { name: 'Feathered Friends in Flight!', location: 'Asia', times: '10:45a, 11:45a, 1:45p, 2:45p, 3:45p', sara: 'Show de aves, muy lindo.' },
    { name: 'Winged Encounters', location: 'Discovery Island', times: '8:15a, 9:15a, 10:15a, 11:15a, 12:15p', sara: 'Aves exoticas en vuelo libre.' },
  ],
}

// ── PARK NARRATIVE FLOW CONNECTORS ──────────────────────────────────────
// Sara's park days are NOT flat checklists — grouped rides with narrative between groups.
// These connectors are inserted between ride groups by docx-generator.js.
export const PARK_NARRATIVE = {
  mk: {
    afterOpeningRides: 'Aqui ya pueden si quieren devolverse por el castillo, caminar por los jardines alrededor y tomar fotos, disfrutar de los lugares cerca al castillo, maravillarse.',
    cavalcadeNote: 'Hay desfile "Disney Adventure Friends Cavalcade" — repite varias veces por si no alcanzan al primero.',
    philharmagicIntro: 'Lindo momento para descansar o comodin de lluvia: Mickey\'s PhilharMagic, me encanta y normalmente a los ninos les FASCINA!',
    lunchTransition: 'Aqui es mas o menos la 1:00 pm. Alli pueden almorzar dependiendo de donde esten (recomendaciones abajo).',
    paradeViewing: 'Si quieren pueden o quedarse en el castillo para el desfile o ir hacia una zona que es mas desocupada y estar alla tipo 2:30 en AdventureLand cerca de Pecos Bill Tall Tale Inn Cafe (estar alli tipo 2:20 pm).',
    friendshipFaire: 'Pueden estar pendientes del Mickey\'s Magical Friendship Faire que se da a las 4:00 pm en el castillo (tiene varios horarios).',
    tomorrowlandTransition: 'Se van a terminar el parque en Tomorrowland.',
    nightParade: 'El desfile nocturno, normalmente es a las 8:15 pm, estar cerca del lugar tipo 7:30 pm. Siempre recomiendo que tomen puestos cerca del castillo y alguien vaya por cosas de comer.',
    happilyCTA: 'Ver el Show a las 9:30 pm, ubicarse o en el centro cerca a la estatua de Walt Disney con Mickey o si esta muy lleno, cerca al restaurante Crystal Palace (The Plaza Restaurant).',
    railroadTip: '*En el parque si quisieran ir de Fantasyland o Mainstreet pueden tomar el Walt Disney World Railroad.',
  },
  hs: {
    afterToyStoryLand: 'Pueden explorar Galaxy\'s Edge con calma. Diagon... digo, Galaxy\'s Edge tiene muchas cosas por hacer y ver.',
    showBreak: 'Es buen momento para ver alguno de los shows si les interesa (ver tabla de entretenimiento arriba).',
    lunchTransition: 'Aqui pueden almorzar (recomendaciones abajo).',
    sunsetBlvdTransition: 'Luego van hacia Sunset Boulevard para Tower of Terror.',
    fantasmicSetup: 'Fantasmic! sera a las 8:30 pm, estar alli idealmente entre 7:50 - 8:00 pm para hacer fila.',
  },
  ep: {
    afterInitialRides: 'Cuando ingresen pueden solicitar un pasaporte y alli tienen actividades en cada lugar del mundo que pueden hacer por todo el parque, es divertido.',
    afterFutureWorld: 'Pueden empezar a recorrer World Showcase. Cada pabellon tiene su encanto, caminen con calma y disfruten.',
    lunchTransition: 'Aqui pueden almorzar — EPCOT tiene los mejores restaurantes de todo Disney.',
    moanaAndWorldShowcase: 'Pueden ver el espacio de Moana que es caminable y super lindo. Alli en el World Showcase hay mucho por hacer, recorran cada pais, vean los shows, entren a las tiendas. En algunos hay actividades para ninos.',
    worldShowcaseTip: 'Recorran cada pabellon, prueben snacks y bebidas tipicas de cada pais. Los favoritos: Mexico, Japon, Francia, Noruega.',
    nightShowSetup: 'Entre 8:00 y 8:30 pm estar en CANTINA SAN ANGEL para comer y ver el show nocturno de las 9:00 pm, es muy lindo.',
  },
  ak: {
    afterPandora: 'Despues de Pandora pueden ir a explorar Africa. Busquen una persona vestida como Russell de la pelicula UP! y reclamen su Manual de Wilderness Explorer.',
    safariTip: 'Kilimanjaro Safaris es mejor en la manana cuando los animales estan mas activos.',
    lunchTransition: 'Aqui pueden almorzar (recomendaciones abajo).',
    asiaTransition: 'Ahora van hacia Asia para Expedition Everest y Kali River Rapids.',
    pandoraNightReturn: 'Al final del dia les recomiendo regresar a Pandora una vez anochezca ya que esta zona de noche es muy especial!',
  },
}

// ── PER-PARK RESTAURANTS ─────────────────────────────────────────────────
export const PARK_RESTAURANTS = {
  mk: [
    // Quick Service
    { name: 'Tortuga Tavern', location: 'Adventureland', type: 'Americana', service: 'quick', sara: 'Buena opción cerca de Pirates. Abre según temporada.', dishes: ['Sándwich de cerdo asado $11.49', 'Hot dog a la barbacoa con ensalada de repollo $12.29', 'Orange Chicken Strips $10.99'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/magic-kingdom/tortuga-tavern/menus/' },
    { name: 'Columbia Harbour House', location: 'Liberty Square', type: 'Mariscos', service: 'quick', sara: 'Fish & chips, nuggets. Tiene segundo piso con menos gente.', dishes: ['Salmón asado $14.29', 'Sea Captain\'s Fish Sandwich $13.29'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/magic-kingdom/columbia-harbour-house/menus' },
    { name: "Cosmic Ray's Starlight Cafe", location: 'Tomorrowland', type: 'Hamburguesas', service: 'quick', sara: 'El más grande de MK. Hamburguesas y pollo. Siempre hay puesto.', dishes: ['Hamburguesa Angus $12.79', 'Grilled chicken sandwich $12.79', 'Greek salad with Chicken $11.59'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/magic-kingdom/cosmic-ray-starlight-cafe/menus' },
    { name: 'Pecos Bill', location: 'Frontierland', type: 'Tex-Mex', service: 'quick', sara: 'Burritos, nachos. El toppings bar es buenísimo.', dishes: ['Burritos', 'Nachos — el toppings bar es buenísimo'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/magic-kingdom/pecos-bill-tall-tale-inn-and-cafe/menus' },
    { name: "The Friar's Nook", location: 'Fantasyland', type: 'Snacks', service: 'quick', sara: 'Menos recomendado pero si están cerca, opciones rápidas.' },
    // Table Service
    { name: 'Skipper Canteen', location: 'Adventureland', type: 'Variada', service: 'table', sara: 'Temático de Jungle Cruise. La comida es buena y diferente.' },
    { name: 'The Crystal Palace', location: 'Main Street', type: 'Buffet con personajes', service: 'table', sara: 'Winnie the Pooh y amigos.' },
    { name: "Cinderella's Royal Table", location: 'Fantasyland', type: 'Americana', service: 'table', sara: 'Comer dentro del castillo.' },
  ],
  hs: [
    // Quick Service
    { name: "Woody's Lunch Box", location: 'Toy Story Land', type: 'Sandwiches', service: 'quick', sara: 'Pueden ordenar online por la APP previo a llegar allí.', dishes: [], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/hollywood-studios/woodys-lunch-box/menus' },
    { name: 'Docking Bay 7', location: "Galaxy's Edge", type: 'Variada', service: 'quick', sara: 'Temático de Star Wars. Los bowls son buenos.', dishes: ['Batuuan Beef and Crispy Topato Stir-fry $18.99', 'Peka Tuna Poke $17.99'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/hollywood-studios/docking-bay-7-food-and-cargo/menus' },
    { name: 'ABC Commissary', location: 'Commissary Lane', type: 'Variada', service: 'quick', sara: 'Opción básica pero funcional. Hamburguesas, pollo.', dishes: ['Pork Carnitas Tacos $12.49', 'Mediterranean Salad with Chicken $12.29'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/hollywood-studios/abc-commissary/menus' },
    { name: 'Backlot Express', location: 'Echo Lake', type: 'Americana', service: 'quick', sara: 'Hamburguesas y nuggets. Buena opción para niños.', dishes: ['Smoked BBQ Pulled Pork Burger $14.79', 'Teriyaki Chicken Bowl $12.99'], menuUrl: 'https://disneyworld.disney.go.com/dining/hollywood-studios/backlot-express/menus' },
    // Table Service
    { name: 'Hollywood & Vine', location: 'Echo Lake', type: 'Americana/Buffet', service: 'table', sara: 'Les da acceso VIP al show de la noche.' },
    { name: 'The Hollywood Brown Derby', location: 'Hollywood Blvd', type: 'Americana', service: 'table', sara: 'El restaurante más elegante de HS. Reserven con anticipación.' },
  ],
  ep: [
    // Quick Service
    { name: 'Connections Cafe', location: 'World Celebration', type: 'Variada', service: 'quick', sara: 'Nuevo, grande, buena opción cerca de la entrada.' },
    { name: 'La Cantina de San Angel', location: 'México', type: 'Mexicana', service: 'quick', sara: 'Tacos y nachos con vista a la pirámide. Me encanta este sitio.', dishes: ['Tacos de Barbacoa $16.00', 'Taco Trio $15.50'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/epcot/cantina-de-san-angel/menus/' },
    { name: 'Katsura Grill', location: 'Japón', type: 'Japonesa', service: 'quick', sara: 'Sushi y teriyaki. Buena calidad, menos fila que Teppan Edo.', dishes: ['Tokyo Sushi Combo $12.00', 'Shrimp and Chicken Teriyaki $15.00'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/epcot/katsura-grill/menus/' },
    { name: 'Les Halles Boulangerie', location: 'Francia', type: 'Francesa', service: 'quick', sara: 'El mejor Quick Service de EPCOT. Los croissants y quiches son increíbles.', dishes: ['Croissant Jambon Fromage $8.95', 'Croque Monsieur $10.50'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/epcot/les-halles-boulangerie-patisserie/menus' },
    { name: 'Regal Eagle Smokehouse', location: 'The American Adventure', type: 'BBQ', service: 'quick', sara: 'Barbecue americano, buenas porciones.' },
    { name: 'Yorkshire County Fish Shop', location: 'UK', type: 'Fish & Chips', service: 'quick', sara: 'Fish & chips buenos, porción grande.' },
    // Table Service
    { name: 'San Angel Inn', location: 'México', type: 'Mexicana', service: 'table', sara: 'Dentro de la pirámide con vista al río. El ambiente es mágico de noche. La comida es buena, reserven.' },
    { name: 'Teppan Edo', location: 'Japón', type: 'Japonesa', service: 'table', sara: 'Teppanyaki con show del chef. Divertido para toda la familia. Reservar con anticipación.' },
    { name: 'Via Napoli', location: 'Italia', type: 'Italiana', service: 'table', sara: 'La mejor pizza de Disney, hecha en horno de leña. Porciones familiares. Muy recomendado.' },
    { name: 'Le Cellier', location: 'Canadá', type: 'Steakhouse', service: 'table', sara: 'El mejor steak de EPCOT. Más caro pero con el Dining Plan vale mucho la pena (se usan 2 créditos).' },
  ],
  ak: [
    // Quick Service
    { name: "Satu'li Canteen", location: 'Pandora', type: 'Bowls/Variada', service: 'quick', sara: 'EL MEJOR Quick Service de todo Disney. Los bowls son increíbles, se los recomiendo.', dishes: ['Combination Bowl: Smoked Chimichurri-braised Beef and Wood-grilled Chicken $17.49'], menuUrl: 'https://disneyworld.disney.go.com/dining/animal-kingdom/satuli-canteen/menus' },
    { name: 'Flame Tree Barbecue', location: 'Discovery Island', type: 'BBQ', service: 'quick', sara: 'Costillas y pollo buenos. Siéntense afuera con vista al agua.', dishes: ['St. Louis Rib Dinner $16.49', 'Smoked Pulled Pork Sandwich $11.79', 'Smokehouse Chicken Salad $11.59'], menuUrl: 'https://disneyworld.disney.go.com/dining/animal-kingdom/flame-tree-barbecue/menus' },
    { name: 'Yak & Yeti Local Food Cafes', location: 'Asia', type: 'Asiática', service: 'quick', sara: 'Opción rápida en Asia. El honey chicken es bueno.', dishes: ['Honey Sesame Chicken $14.99', 'Sweet-and-Sour Tempura Shrimp $16.99'], menuUrl: 'https://disneyworld.disney.go.com/es-co/dining/animal-kingdom/yak-and-yeti-local-foods-cafe/menus/lunch%20and%20dinner' },
    { name: 'Harambe Market', location: 'Africa', type: 'Africana', service: 'quick', sara: 'Puestos de comida estilo mercado. Las salchichas con maíz son populares.', dishes: ['Ribs & Chicken Bowl $14.99', 'Harambe Salad $10.29'], menuUrl: 'https://disneyworld.disney.go.com/dining/animal-kingdom/harambe-market/menus' },
    // Table Service
    { name: 'Yak & Yeti', location: 'Asia', type: 'Asiática', service: 'table', sara: 'Comida asiática variada con buen ambiente. El Ahi Tuna y el Mahi Mahi son excelentes.' },
    { name: 'Tusker House', location: 'Africa', type: 'Buffet/Africana', service: 'table', sara: 'Buffet con personajes (Donald y amigos en ropa de safari). Buena comida y experiencia divertida para los niños.' },
  ],
}

// ── MEAL PLAN SECTION ────────────────────────────────────────────────────
// Template — {planType} and day allocations are personalized
export const MEAL_PLAN = {
  title: 'Plan de Comidas Disney',

  intro: `Con el plan de comidas, tienen créditos diarios para usar en restaurantes dentro de Disney. Los créditos se acumulan durante toda la estadía, así que pueden redistribuirlos como quieran.`,

  types: {
    quick_service: {
      name: 'Quick Service Dining Plan',
      perDay: '2 comidas Quick Service + 1 Snack por persona por día',
      tip: 'Quick Service = restaurantes donde piden en mostrador, sin reservación. Práctico y rápido, no pierden tiempo esperando mesa.',
      restaurantNote: 'Con su plan Quick Service, los restaurantes marcados abajo son donde pueden usar sus créditos. Pidan en mostrador, busquen mesa, y listo.',
    },
    standard: {
      name: 'Disney Dining Plan',
      perDay: '1 comida Quick Service + 1 comida Table Service + 1 Snack por persona por día',
      tip: 'Tienen 1 crédito diario para restaurante con mesero (Table Service). RESERVEN con 60 días de anticipación — los buenos se llenan.',
      restaurantNote: 'Con su Disney Dining Plan tienen créditos Quick Service Y Table Service. Los Table Service necesitan reservación — háganla con anticipación en la app My Disney Experience.',
    },
  },

  snackTip: 'Los snacks incluyen: helados Mickey, pretzels, palomitas, frutas, bebidas, y más. Busquen el símbolo del plan de comidas en el menú.',
}

// ── INFORMACIÓN ADICIONAL ────────────────────────────────────────────────
// 100% reusable — identical across all 6 PDFs
export const INFO_ADICIONAL = {
  title: 'Información Adicional',

  contacts: {
    title: 'Contactos de Emergencia / Apoyo en Orlando',
    items: [
      { name: 'Carlos Gonzalez', role: 'Transporte privado (tipo Uber), súper recomendado', phone: '+1 (321) 440-2152' },
      { name: 'Pedro Howard', role: 'En caso que Carlos no esté disponible', phone: '+1 (770) 274-9413' },
    ],
    note: 'Si necesitan CUALQUIER cosa mientras están allá, escríbanles con confianza. Están para ayudarlos.',
  },

  orlandoActivities: {
    title: 'Planes adicionales en Orlando',
    categories: [
      {
        name: 'Playgrounds y parques (gratuitos)',
        items: ['Cherry Tree Park', 'Lake Eola Park', 'Yucatan Park', 'Demetree Park Playground', 'Phelps Park Playground', 'Lake Lorna Doone Park'],
      },
      {
        name: 'Splash Parks (gratuitos normalmente)',
        items: ['Apopka Splash Pad', 'Dr. P. Phillips Community Park', 'St. Cloud Lakefront Park', 'Kissimmee Lakefront Park', 'Barnett Park', 'Bithlo Community Park', 'Capehart Park', 'Casey Jr. Splash \'N\' Soak Station'],
      },
      {
        name: 'Parques temáticos o experiencias',
        items: ['World\'s Largest Entertainment McDonald\'s & PlayPlace', 'Crayola Experience', 'ICON Park', 'Legoland'],
      },
      {
        name: 'Parques acuáticos',
        items: ['Treasure Cove Water Park', 'CoCo Key Water Park'],
      },
      {
        name: 'Parques Naturales',
        items: ['Crystal River', 'Kelly Park and Rock Springs', 'Wekiwa Springs State Park', 'De Leon Springs State Park'],
      },
    ],
  },

  essentialTips: {
    title: 'Tips Esenciales',
    items: [
      'Bloqueador solar: Es obligatorio. El sol de Florida pega diferente.',
      'Zapatos cómodos: Van a caminar 15,000-25,000 pasos por día. En serio.',
      'Batería portátil: El celular con la app de Disney dura la mitad.',
      'Poncho de lluvia: En verano llueve todos los días ~30 min. Compren en Dollar Tree, no en el parque ($15+ vs $1).',
      'Botella de agua: Hay fuentes gratis en todos los parques. Incluso pueden pedir vaso de agua gratis en cualquier Quick Service.',
      'Cargador del coche: Lleven cable largo para cargar en el carro.',
    ],
  },
}

// ── OUTLET / SHOPPING ────────────────────────────────────────────────────
// 100% reusable
export const SHOPPING = {
  title: 'Compras y Outlets',
  intro: 'Orlando tiene dos outlets principales. Mi recomendación:',
  outlets: [
    {
      name: 'Orlando International Premium Outlets',
      address: '4951 International Dr',
      tip: 'El más grande. Tiene Nike, Adidas, Under Armour, Coach, Kate Spade, Michael Kors, y más. Dedíquenle al menos 2-3 horas.',
    },
    {
      name: 'Orlando Vineland Premium Outlets',
      address: '8200 Vineland Ave',
      tip: 'Más cerca de Disney. Tiene marcas similares pero es más pequeño. Buena opción si no quieren ir lejos.',
    },
  ],
  stores: [
    { name: 'Premium Outlets', tip: 'Cualquiera de los dos tiene muchas muchísimas opciones. Nike, Adidas, Under Armour, Coach, Kate Spade, Michael Kors.' },
    { name: 'Nordstrom Rack', tip: 'Para marcas un poco más premium que Ross, recomiendo mucho.' },
    { name: 'DSW', tip: 'Para zapatos solamente me gusta mucho DSW.' },
    { name: 'Primark', tip: 'En Florida Mall. Para cosas económicas algunos viajeros disfrutan mucho.' },
    { name: 'HomeGoods', tip: 'Para cosas de casa.' },
    { name: 'Ross', tip: 'Cosas interesantes a buen precio.' },
    { name: 'TJ Maxx', tip: 'Similar a Ross, buenos hallazgos.' },
    { name: "Dick's Sporting Goods", tip: 'Elementos deportivos.' },
  ],
  shoppingTips: [
    'Vayan en la mañana o entre semana — los fines de semana se llenan mucho.',
    'Revisen la app de cada outlet antes de ir — tienen cupones adicionales.',
  ],
}

// ── EPIC UNIVERSE (Universal) ────────────────────────────────────────────
// Zone-by-zone guide from Alejandra De los Rios PDF
export const EPIC_UNIVERSE = {
  name: 'Epic Universe',
  code: 'epic',
  arrivalTip: 'Lleguen tipo 8:20 am al parque. OJO: este parque al ser nuevo, tiene muy pocas plantas altas, poca sombra. Mucha hidratación, gorras y mucho bloqueador.',

  walkingDirections: 'Deben tomar dos decisiones: ir directo a Ministry of Magic o comenzar con Dark Universe. Yo personalmente comenzaría con Dark Universe. Si Mind Card Madness tiene menos de 40 minutos de fila cuando están ingresando, entren corriendo hacia Super Nintendo World, pero no paren a tomar fotos, luego vuelven al final del día.',

  zones: [
    {
      name: 'Dark Universe',
      sara: 'Esta zona es un poco "oscura", perfecta para quienes aman las casas del terror o el misterio. Toda la zona está increíblemente bien ambientada.',
      rides: [
        { name: 'Monsters Unchained: The Frankenstein Experiment', sara: 'Más que fuerte puede ser asustadora, pero no tan grave.' },
        { name: 'Curse of the Werewolf', sara: 'Es divertida para todos.' },
      ],
      restaurants: [
        { name: 'Das Stakehaus', sara: 'Restaurante temático de "vampiros", carnes asadas y ambientación bastante "Dark".' },
        { name: 'The Burning Blade Tavern', sara: 'Un lugar acogedor.' },
      ],
    },
    {
      name: 'How to Train Your Dragon — Isle of Berk',
      sara: 'Una zona hermosa para explorar, perfecta para algún snack o para almorzar.',
      rides: [
        { name: "Hiccup's Wing Gliders", sara: 'Para mí una de las preferidas del parque.' },
        { name: "Dragon Racer's Rally", sara: 'Yo personalmente no soy muy fan de este ride, pero mucha gente lo ama. Es tipo sillas voladoras.' },
        { name: 'Fyre Drill', sara: 'Van a salir mojados.' },
      ],
      shows: [
        { name: 'The Untrainable Dragon Show', sara: 'Es MUY lindo, no se lo pierdan.' },
      ],
      restaurants: [
        { name: 'Spit Fyre Grill', sara: 'Quiosquito al aire libre, el salmón es rico y tienen buena comida con verduras.' },
        { name: 'Mead Hall', sara: 'Una cuevita deliciosa con aire acondicionado y buena comida.' },
      ],
    },
    {
      name: 'Celestial Park',
      sara: 'El corazón del parque, el centro. Tiene mucho espacio y diferentes cosas para ver y comer.',
      rides: [
        { name: 'Stardust Racers', key: 'stardust_racers', sara: 'Es muy buena, una de mis favoritas. Pueden hacerla por Single Rider.', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'Es la montana rusa principal de Epic Universe. Si se animan, es espectacular.' },
        { name: 'Constellation Carousel', sara: '¡Es muy lindo en la noche especialmente!' },
      ],
      restaurants: [
        { name: 'Pizza Moon', sara: 'Restaurante muy lindo y temático. Pizzas gourmet muy buenas. ¡Son deliciosas!' },
      ],
    },
    {
      name: 'The Wizarding World of Harry Potter — Ministry of Magic',
      sara: 'Esta parte del parque es supremamente especial, sobre todo para los fans de Harry Potter.',
      rides: [
        { name: 'Harry Potter and the Battle of the Ministry', sara: 'Un ride impresionante. La fila es larga, MUY larga normalmente.' },
      ],
      shows: [
        { name: 'Show de Harry Potter', sara: 'Bastante lindo, lo súper recomiendo. Hagan fila 30 minutos antes.' },
      ],
      restaurants: [
        { name: 'Le Cirque Arcanus Café', sara: 'A mí me fascina, la comida es rica y saludable. Recomendada la sopa de Cebolla.' },
        { name: 'The Cauldron Bar', sara: 'Para una bebida mágica.' },
      ],
    },
    {
      name: 'SUPER NINTENDO WORLD',
      sara: 'Este mundo toma MUCHO tiempo.',
      rides: [
        { name: 'Donkey Kong: Mine Cart Madness', sara: 'Hacerla idealmente al inicio del día.', isCoaster: true, coasterType: 'suave' },
        { name: 'Mario Kart: Bowser\'s Challenge', sara: '' },
        { name: "Yoshi's Adventure", sara: 'Es más para niños chiquitos, si hay poca fila perfecto. Si hay mucha fila, no la hagan.' },
      ],
      restaurants: [
        { name: 'Toadstool Café', sara: 'Decorado como la casa de Toad, es una ternura. La comida es rica y sencilla, y su temática es HERMOSA.' },
        { name: "Yoshi's Snack Stand", sara: 'Ideal para snacks rápidos y bebidas.' },
      ],
    },
  ],

  diningUpscale: [
    { name: 'Atlantic', sara: 'Restaurante de mariscos con temática submarina.' },
    { name: 'Blue Dragon Pan-Asian Restaurant', sara: 'Platos asiáticos en un ambiente elegante. Requiere reservas y es muy apetecido.' },
  ],

  closingTip: 'Al cierre del parque pueden sentarse a ver el show de la fuente frente al Helios.',
}

// ── UNIVERSAL STUDIOS ORLANDO / IOA (basic) ──────────────────────────────
export const UNIVERSAL_PARKS = {
  uso: {
    name: 'Universal Studios Orlando',
    code: 'uso',
    arrivalTip: 'Vayan a Diagon Alley y directo a Harry Potter and the Escape from Gringotts.',
    topRides: [
      { name: 'Harry Potter and the Escape from Gringotts', sara: '' },
      { name: 'Transformers: The Ride 3D', sara: '' },
      { name: 'Revenge of the Mummy', sara: 'Súper buena, puede ser un poquito miedosa y es montaña rusa, pero si están dispuestos a la adrenalina, es muy chévere.', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'Es montana rusa indoor, corta pero intensa. Si se animan, es muy divertida.' },
      { name: 'Villain-Con Minion Blast', sara: 'A los niños les encanta.' },
      { name: 'E.T. Adventure', sara: '' },
    ],
    diagonAlleyTip: 'Diagon Alley tiene muchas cosas por hacer y ver. Pueden comprar una varita interactiva, LES SERVIRÁ EN TODOS LOS PARQUES. Hay caminitos por todas partes, recórranlo todo. El Dragon tira fuego cada 10 minutos.',
    notRecommended: [
      { name: 'Fast & Furious', sara: '' },
      { name: 'The Simpsons Ride', sara: '' },
      { name: 'Despicable Me Minion Mayhem', sara: '' },
    ],

    walkingDirections: 'De donde pasan el filtro de seguridad caminen hacia el CityWalk. Cuando pasen la botella gigante de Coca Cola, vayan hacia la derecha para entrar por Universal. Vayan a Diagon Alley y vayan directo a Harry Potter and the Escape from Gringotts.',
  },
  ioa: {
    name: 'Islands of Adventure',
    code: 'ioa',
    arrivalTip: 'Estén allí a las 7:30 am idealmente. Vayan directo a Hagrid\'s Motorbike, no tomen fotos, no paren aún.',
    topRides: [
      { name: "Hagrid's Magical Creatures Motorbike Adventure", key: 'hagrids_motorbike', sara: '', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'Es la atraccion mas popular del parque. Si se animan, vale MUCHO la pena.' },
      { name: 'VelociCoaster', key: 'velocicoaster', sara: 'Es BIEN EXTREMA.', isCoaster: true, coasterType: 'extrema', noCoasterNote: null },
      { name: 'Harry Potter and the Forbidden Journey', sara: '', isCoaster: true, coasterType: 'intensa', noCoasterNote: 'No es montana rusa tradicional, es mas un simulador con movimiento. Puede marear un poco.' },
      { name: 'Flight of the Hippogriff', sara: 'Es chiquita pero es súper.', isCoaster: true, coasterType: 'suave' },
      { name: 'The Amazing Adventures of Spider-Man', sara: '' },
      { name: 'The Incredible Hulk Coaster', key: 'hulk_coaster', sara: 'Tiene un arranque fuerte.', isCoaster: true, coasterType: 'extrema', noCoasterNote: null },
    ],
    hogsmeadeTip: 'Exploren Hogsmeade, es espectacular. Pueden hacer trucos con la varita, ver el Wand Experience de Ollivanders, mandar una carta desde la oficina de correos, comer ranas de chocolate de Honeydukes.',
    notRecommended: [
      { name: 'Skull Island: Reign of Kong', sara: 'No es la más recomendada, pero puede que la disfruten.' },
    ],

    walkingDirections: 'Van a ir derecho, y en el primer cruce que encuentren antes de un laguito, cruzan a la derecha (caminando hacia Seuss Landing). Una vez pasan el puentecito de Seuss Landing, allí ven como un playground, cruzan de una a la izquierda, van derecho bordeando el lago (allí van pasando por debajo como de unos rieles del trencito), siguen y llegan a otro puente que ya es la entrada a otro land, donde ven a Poseidon, siguen derecho por todo ese land que se llama Lost Continent, y cuando llegan a una fuente que se llama Mystic Fountain, van levemente a la izquierda y se encuentran la estación del Tren de Harry Potter a mano derecha, siguen derecho, y ahí una vez ven el tren y un barril, a mano derecha está la entrada al primer ride: Hagrid\'s Motorbike Adventure.',
  },
}

// ── CITY WALK RESTAURANTS (Universal) ────────────────────────────────────
// 100% reusable
export const CITY_WALK = {
  title: 'CityWalk — Restaurantes Recomendados',
  intro: 'CityWalk es la zona de restaurantes y entretenimiento de Universal. No necesitan entrada, es gratis.',
  restaurants: [
    { name: 'Bubba Gump', type: 'Mariscos/Americana', sara: 'Temático de la película Forrest Gump. Camarones buenos.' },
    { name: 'Antojitos', type: 'Mexicana', sara: 'Comida mexicana, buenas margaritas.' },
    { name: 'Bend the Bao', type: 'Asiática', sara: 'Baos rellenos, rápido y diferente.' },
    { name: 'VIVO Italian Kitchen', type: 'Italiana', sara: 'Pastas y pizzas. Buena opción para familias.' },
    { name: 'Toothsome Chocolate Emporium', type: 'Americana/Postres', sara: 'Los milkshakes y postres son espectaculares. Para los golosos.' },
  ],
}

// ── SINGLE RIDER (Universal) ───────────────────────────────────────────
export const SINGLE_RIDER = {
  title: 'Single Rider Line',
  explanation: `Estas son filas diferentes a las normales, donde pueden separar su "party" o grupo. Es decir, que si van 4 personas, puede que a los 4 les toque en "carritos, vagones, o momentos" diferentes de la atracción. Por esta razón las filas Single Rider tienden a ser más rápidas que las normales. Recomiendo mucho usarlas.`,
  rides: [
    "Doctor Doom's Fearfall",
    'Harry Potter and the Forbidden Journey',
    "Hagrid's Magical Creatures Motorbike Adventure",
    'Jurassic World VelociCoaster',
    'The Incredible Hulk Coaster',
    'Men In Black Alien Attack',
    'Transformers: The Ride 3D',
  ],
}

// ── EXPERIENCE LABELS (for raw token → human-readable) ─────────────────
// Used in DOCX personalization section to avoid exposing raw keys
export const EXPERIENCE_LABELS = {
  photo_package: 'Paquete de fotos (Memory Maker)',
  character_dining: 'Cena con personajes',
  dessert_party: 'Dessert Party',
  bibbidi_bobbidi: 'Bibbidi Bobbidi Boutique',
  guardians_of_galaxy: 'Guardians of the Galaxy: Cosmic Rewind',
  christmas_party: "Mickey's Very Merry Christmas Party",
  halloween_party: "Mickey's Not-So-Scary Halloween Party",
  water_parks: 'Parques Acuaticos (Typhoon Lagoon / Blizzard Beach)',
  mini_golf: 'Mini Golf (Fantasia Gardens / Winter Summerland)',
  behind_the_seeds: 'Behind the Seeds Tour (EPCOT)',
  enchanting_extras: 'Enchanting Extras Collection',
  fireworks_cruise: 'Fireworks Cruise',
  vip_tour: 'VIP Tour Guide',
  rider_switch: 'Rider Switch (padres se turnan)',
  early_entry: 'Early Entry (30 min antes)',
  extended_evening: 'Extended Evening Hours (solo Deluxe)',
  express_pass: 'Express Pass (Universal)',
  park_hopper: 'Park Hopper',
  dining_plan: 'Plan de Comidas Disney',
  lightning_lane: 'Lightning Lane Multi Pass',
  single_pass: 'Lightning Lane Single Pass',
  memory_maker: 'Memory Maker (fotos ilimitadas)',
}

// ── SECTION MARKERS ──────────────────────────────────────────────────────
// Used for DOCX hidden markers — enables re-upload parsing
// White 1pt font, invisible to Sara, but parseable by mammoth
export const SECTION_MARKERS = {
  greeting: '{{M2M_SECTION:GREETING}}',
  agenda: '{{M2M_SECTION:AGENDA}}',
  lightningLane: '{{M2M_SECTION:LIGHTNING_LANE}}',
  disneySprings: '{{M2M_SECTION:DISNEY_SPRINGS}}',
  checkIn: '{{M2M_SECTION:CHECK_IN}}',
  parkDay: (parkCode, dayNum) => `{{M2M_SECTION:PARK_DAY:${parkCode}:${dayNum}}}`,
  parkRides: (parkCode) => `{{M2M_SECTION:PARK_RIDES:${parkCode}}}`,
  parkRestaurants: (parkCode) => `{{M2M_SECTION:PARK_RESTAURANTS:${parkCode}}}`,
  parkCharacters: (parkCode) => `{{M2M_SECTION:PARK_CHARACTERS:${parkCode}}}`,
  parkShows: (parkCode) => `{{M2M_SECTION:PARK_SHOWS:${parkCode}}}`,
  mealPlan: '{{M2M_SECTION:MEAL_PLAN}}',
  infoAdicional: '{{M2M_SECTION:INFO_ADICIONAL}}',
  shopping: '{{M2M_SECTION:SHOPPING}}',
  epicUniverse: '{{M2M_SECTION:EPIC_UNIVERSE}}',
  cityWalk: '{{M2M_SECTION:CITY_WALK}}',
  personalization: '{{M2M_SECTION:PERSONALIZATION}}',
}

// ── HOTEL TIER CLASSIFICATION ──────────────────────────────────────────
// Detect hotel tier from lead.hotels[] for early entry / extended hours / Express Pass

export const SKYLINER_HOTELS = ['Caribbean Beach', 'Pop Century', 'Art of Animation', 'Riviera']

export const SKYLINER_EPCOT_TIP = 'Hay una opción para entrar al parque, y lo pueden hacer tomando el Skyliner a Epcot. Esto lo que les permite es ingresar por la parte "trasera" del parque que es el International Gateway, la razón de esta entrada es que los deja al lado de Ratatouille que es la atracción por la cual les recomiendo comenzar.'

export const DISNEY_PROPERTIES = {
  deluxe: [
    'Grand Floridian', 'Contemporary', 'Polynesian', 'Animal Kingdom Lodge',
    'Wilderness Lodge', 'Beach Club', 'Yacht Club', 'BoardWalk', 'Riviera',
    'Swan', 'Swan Reserve', 'Dolphin',
  ],
  moderate: [
    'Port Orleans', 'Caribbean Beach', 'Coronado Springs', 'Fort Wilderness',
    'Cabins at Fort Wilderness',
  ],
  value: [
    'All-Star Sports', 'All-Star Movies', 'All-Star Music',
    'Pop Century', 'Art of Animation',
  ],
}

export const UNIVERSAL_PROPERTIES = {
  premier: ['Royal Pacific', 'Hard Rock', 'Portofino Bay'],
  preferred: ['Cabana Bay', 'Aventura', 'Endless Summer Surfside', 'Endless Summer Dockside'],
  prime_value: ['Stella Nova', 'Terra Luna', 'Helios'],
}

export function classifyHotel(lead) {
  const result = {
    isDisneyGuest: false,
    isUniversalGuest: false,
    disneyTier: null,       // 'deluxe' | 'moderate' | 'value' | null
    universalTier: null,    // 'premier' | 'preferred' | 'prime_value' | null
    hotelName: '',
  }

  const hotels = lead.hotels || []
  if (!hotels.length) {
    // Check formData for hotel info
    const fd = lead.formData || {}
    if (fd.hotelEspecifico) {
      hotels.push({ name: fd.hotelEspecifico, provider: '', type: '' })
    }
  }

  for (const h of hotels) {
    const name = (h.name || '').toLowerCase()
    const provider = (h.provider || '').toLowerCase()
    const type = (h.type || '').toLowerCase()

    // Check explicit provider first
    if (provider.includes('disney') || provider === 'vax') {
      result.isDisneyGuest = true
      result.hotelName = h.name || result.hotelName
    }
    if (provider.includes('universal')) {
      result.isUniversalGuest = true
      result.hotelName = h.name || result.hotelName
    }

    // Check explicit type field
    if (type.includes('deluxe')) { result.disneyTier = 'deluxe'; result.isDisneyGuest = true }
    if (type.includes('moderate')) { result.disneyTier = 'moderate'; result.isDisneyGuest = true }
    if (type.includes('value')) { result.disneyTier = 'value'; result.isDisneyGuest = true }
    if (type.includes('premier')) { result.universalTier = 'premier'; result.isUniversalGuest = true }
    if (type.includes('preferred')) { result.universalTier = 'preferred'; result.isUniversalGuest = true }

    // Name-based detection (fallback if type not set)
    if (!result.disneyTier) {
      for (const [tier, props] of Object.entries(DISNEY_PROPERTIES)) {
        if (props.some(p => name.includes(p.toLowerCase()))) {
          result.disneyTier = tier
          result.isDisneyGuest = true
          result.hotelName = h.name || result.hotelName
          break
        }
      }
    }
    if (!result.universalTier) {
      for (const [tier, props] of Object.entries(UNIVERSAL_PROPERTIES)) {
        if (props.some(p => name.includes(p.toLowerCase()))) {
          result.universalTier = tier
          result.isUniversalGuest = true
          result.hotelName = h.name || result.hotelName
          break
        }
      }
    }
  }

  return result
}

// ── HELPER: Generate per-child ride notes ────────────────────────────────
// Uses grupoViajeros names + ages to generate personalized height warnings
export function generateChildNotes(rideKey, grupoViajeros) {
  if (!grupoViajeros?.length) return null
  const minH = HEIGHT_REQUIREMENTS[rideKey]
  if (!minH) return null

  const notes = []
  for (const v of grupoViajeros) {
    if (!v.esMenor || !v.edad) continue
    const age = parseInt(v.edad)
    if (isNaN(age)) continue
    const childH = AGE_TO_HEIGHT[age] || (age > 12 ? 160 : 85)
    const name = v.nombre || `Niño/a (${age} años)`
    if (childH < minH) {
      notes.push(`OJO: ${name} (${age} años, ~${childH} cm) probablemente no alcanza la altura minima de ${minH} cm`)
    } else if (childH < minH + 10) {
      notes.push(`* ${name} (${age} años, ~${childH} cm) puede estar justo en el limite — midan antes de hacer fila`)
    }
  }
  return notes.length > 0 ? notes : null
}
